  export enum ReviewActionTypes {
    POST_TRAVELLER_DETAILS = 'POST_TRAVELLER_DETAILS',
    GET_TRAVELLER_DETAILS_CHECKOUT = 'GET_TRAVELLER_DETAILS_CHECKOUT',
    GET_TRAVELLER_DETAILS = 'GET_TRAVELLER_DETAILS',
    GET_QUOTES = 'GET_QUOTES',
    PROCEED_REVIEW='PROCEED_REVIEW',
    PROCEED_BUY = 'PROCEED_BUY',
    GET_VAT = 'GET_VAT',
  }
  